/**
 * GraphQL ID (GID) utilities
 * @module shared-cart/utils/gid
 */

/**
 * Strips the GraphQL GID prefix to extract the numeric ID
 * @param {string} str - A GraphQL GID (e.g., "gid://shopify/ProductVariant/123")
 * @returns {string} The numeric ID portion (e.g., "123")
 */
export function stripGid(str: string | null | undefined): string | null | undefined {
  if (!str?.includes('gid://')) return str;
  return str.split('/').pop();
}

/**
 * Extracts SKUs from an array of handoff items
 * @param {Array<{id: string, qty: number}>} items - Array of handoff items
 * @returns {string[]} Array of SKU strings
 */
export function extractSkus(items: Array<{ id?: string | number | null } | null>): string[] {
  return items.map((item) => (item?.id ? String(item.id) : '')).filter((sku) => sku);
}
